import React, { useCallback } from 'react';

import { SSRMediaQuery } from 'components/SSRMediaQuery';
import { useWtrSelector } from 'redux/hooks';
import { getGroupNameByIndex } from 'components/Builder/selectors';

import { BREAKPOINTS } from 'constants/grid';
import { slowlyScrollPageVerticallyTo } from 'utils/scroll';
import { getElementById } from 'utils/get-element-wrapper';
import { BaseGroupItemPlaceholder } from 'components/Builder/types';

import MobileLine from './MobileLine';
import LineView from './LineView';

const topOffset = 138;

export interface BuilderLineProps {
  builderIndex: number;
  collapsed: boolean;
  groupId: string;
  GroupItemPlaceholder: BaseGroupItemPlaceholder;
  groupIndex: number;
  promotionId?: string;
  builderId?: string;
  variant: 'bundle' | 'meal deal' | 'offer' | 'wine';
}

const BuilderLine = ({
  builderIndex,
  collapsed,
  groupId,
  GroupItemPlaceholder,
  groupIndex,
  promotionId,
  builderId,
  variant,
}: BuilderLineProps) => {
  const name = useWtrSelector(state =>
    getGroupNameByIndex(state, { promotionId, index: builderIndex, variant, groupIndex }),
  );

  const handleDesktopSlotClick = useCallback(() => {
    if (!name) {
      return;
    }

    slowlyScrollPageVerticallyTo(
      topOffset +
        (getElementById(name)?.offsetTop ?? 0) +
        (getElementById('cms-header-content')?.offsetHeight ?? 0),
    );
  }, [name]);

  return (
    <>
      <SSRMediaQuery maxWidth={BREAKPOINTS.lg}>
        <MobileLine
          builderIndex={builderIndex}
          collapsed={collapsed}
          groupId={groupId}
          GroupItemPlaceholder={GroupItemPlaceholder}
          groupIndex={groupIndex}
          name={name}
          promotionId={promotionId}
          variant={variant}
          builderId={builderId}
        />
      </SSRMediaQuery>
      <SSRMediaQuery minWidth={BREAKPOINTS.lg}>
        <LineView
          builderIndex={builderIndex}
          collapsed={collapsed}
          GroupItemPlaceholder={GroupItemPlaceholder}
          isMobile={false}
          groupIndex={groupIndex}
          name={name}
          onSlotClick={handleDesktopSlotClick}
          promotionId={promotionId}
          variant={variant}
        />
      </SSRMediaQuery>
    </>
  );
};

BuilderLine.displayName = 'BuilderLine';

export default BuilderLine;
